<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0">
          <i class="fas fa-vector-square"></i> Egységek
        </h1>
      </div>
      <div class="ms-auto" v-if="user && user.role_id == 1">
        <button
          class="btn btn-success btn-rounded px-4 rounded-pill"
          v-b-modal.addUnitModal
        >
          <i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új egység
        </button>
      </div>
    </div>
    <b-modal
      id="addUnitModal"
      cancel-variant="default"
      @cancel="closeAddModal()"
      @ok="addUnit"
      ok-title="Létrehozás"
      cancel-title="Mégse"
      :ok-disabled="loading"
      @shown="$refs.add_unit_modal_number_input.focus()"
    >
      <template slot="modal-header">
        <h4 class="modal-title">Új egység</h4>
        <a class="btn-close" @click="closeAddModal()"></a>
      </template>
      <form
        @submit.prevent="addUnit()"
        ref="unit_modal_form"
        v-if="loading == false"
      >
        <div class="form-group">
          <label class="form-label">Egység szám:</label>
          <input
            ref="add_unit_modal_number_input"
            class="form-control text-center"
            :class="{ 'is-invalid': errors.name }"
            type="number"
            v-model="unit.number"
            required
          />
          <div v-if="errors.number" class="invalid-feedback d-block">
            {{ errors.number[0] }}
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Megnevezés:</label>
          <input
            ref="add_unit_modal_name_input"
            class="form-control text-center"
            :class="{ 'is-invalid': errors.name }"
            type="text"
            v-model="unit.name"
            required
          />
          <div v-if="errors.name" class="invalid-feedback d-block">
            {{ errors.name[0] }}
          </div>
        </div>
        <div class="form-group my-2">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="unit.is_radiating"
            />
            <label class="form-check-label" for="is_radiating"
              >Sugárvédelem szükséges!</label
            >
          </div>
        </div>
        <button class="d-none"></button>
      </form>
      <Loading v-else title="Létrehozás"></Loading>
    </b-modal>
    <panel title="Egységek">
      <Loading v-if="units === false" title="Egységek betöltése"></Loading>
      <NoRecords
        v-if="units.length == 0"
        main_icon="fas fa-user-lock"
        value="false"
        title="Nincsenek egységek"
        subtitle="hozzon létre újat"
      ></NoRecords>
      <vue-good-table
        v-if="units.length != 0 && units !== false"
        :columns="columns"
        :rows="units"
        :lineNumbers="true"
        :search-options="{ enabled: false, placeholder: 'Keresés...' }"
        :pagination-options="{
          enabled: true,
          position: 'bottom',
          firstLabel: 'Első Lap',
          lastLabel: 'Utolsó Lap',
          nextLabel: 'következő',
          prevLabel: 'előző',
          rowsPerPageLabel: 'Sor oldalanként',
          ofLabel: '/',
          allLabel: 'Összes',
          infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <router-link
              :to="'units/' + props.row.id + '/edit'"
              class="btn btn-primary mx-1"
              title="szerkesztés"
              ><i class="fa fa-pen"></i
            ></router-link>
            <button
              @click="deleteUnit(props.row.id)"
              class="btn btn-danger mx-1"
              title="törlés"
            >
              <i class="fa fa-trash"></i>
            </button>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </panel>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Box from "../../apis/Box";
import Confirmation from "../../apis/Confirmation";

export default {
  components: {
    Loading,
    NoRecords,
  },
  data() {
    return {
      columns: [
        {
          label: "Szám",
          field: "number",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a számok között",
          },
        },
        {
          label: "Megnevezés",
          field: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Sugárvédelem szükséges",
          field: (row) => (row.is_radiating == 1 ? "Igen" : "Nem"),
        },
        {
          label: "Műveletek",
          field: "actions",
          width: "15%",
          sortable: false,
          thClass: "text-end",
          tdClass: "text-end",
          hidden: true,
        },
      ],
      units: false,
      unit: { is_unit: 1, is_radiating: 0 },
      errors: [],
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    user: {
      handler(val) {
        if (val && val.role_id == 1) {
          this.$set(this.columns[3], "hidden", false);
        } else {
          this.$set(this.columns[3], "hidden", true);
        }
      },
      deep: true,
    },
  },
  created() {
    Box.units().then((response) => {
      this.units = response.data;
    });
    if (this.user.role_id == 1) {
      this.$set(this.columns[3], "hidden", false);
    }
  },
  methods: {
    closeAddModal() {
      this.unit = { is_unit: 1 };
      this.errors = [];
      this.$bvModal.hide("addUnitModal");
    },
    addUnit(bvModalEvt) {
      this.loading = true;
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }
      Box.add(this.unit)
        .then((response) => {
          this.units.unshift(response.data);
          this.errors = [];
          this.closeAddModal();
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteUnit(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          Box.delete(id)
            .then(() => {
              this.units.splice(
                this.units.map((unit) => unit.id).indexOf(id),
                1
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style></style>
